export default {
  CLOUD:  'cloud',
  DEVICE: 'device'
};
